import React from 'react'
import moment from 'moment'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { apiFormat, format } from '@cbgms/base/utils/datetime'
import { StatisticsSubset } from '@cbgms/api/modules/statistics'
import { ChartOptions } from './Charts/ChartOptions/ChartOptions'

interface GenericStatsYearChartProps {
  data: StatisticsSubset[]
  entityTranslation: string
}

const GenericStatsYearChart: React.FC<GenericStatsYearChartProps> = props => {
  const mappedData = props.data.map(row => {
    return {
      name: moment(row.StartDate, apiFormat.yearMonthDay).format(format.year),
      y: row.Total
    }
  })

  const options = ChartOptions(mappedData, '55%', true)

  if (options.series) {
    options.series[0].name = props.entityTranslation
  }

  return (
    <div className='chart'>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  )
}

export default GenericStatsYearChart
